import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import "../styles/Footer.css"
function Footer(props) {
    return (
        <div className='footer'>
           <div className="socialMedia">
            <a target="_blank" rel="noreferrer" href="https://github.com/a656q59"><GitHubIcon/> </a>
           </div> 
           <p>&copy; 2023</p>
        </div>
    );
}

export default Footer;